/* unplugin-vue-components disabled */import { render } from "./TaskCard.vue?vue&type=template&id=5117a053&scoped=true"
import script from "./TaskCard.vue?vue&type=script&lang=js"
export * from "./TaskCard.vue?vue&type=script&lang=js"

import "./TaskCard.vue?vue&type=style&index=0&id=5117a053&lang=scss"
import "./TaskCard.vue?vue&type=style&index=1&id=5117a053&lang=scss&scoped=true"

import exportComponent from "D:\\pangu_artificial_intelligence_ui\\node_modules\\vue-loader-v16\\dist\\exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-5117a053"]])

export default __exports__